import {
  AFRICAN_KINGDOM_RELICS,
  AZTEC_TEMPLE_RELICS,
  CELTIC_RITUAL_RELICS,
  CHINESE_RELICS,
  EGYPTIAN_TOMB_RELICS,
  GREEK_TEMPLE_RELICS,
  FORGOTTEN_RELICS,
  ROMAN_EMPIRE_RELICS,
  MESOPOTAMIAN_RELICS,
  MEDIEVAL_MONASTERY_RELICS,
  PERSIAN_RELICS,
  SHINTO_SHRINE_RELICS,
  VIKING_RELICS,
  INDIAN_TEMPLE_RELICS,
  FEODAL_JAPAN_RELICS,
} from "./questRelics";

export const QUEST_TREASURE_COLLECTIONS = [
  {
    id: "aztec",
    listTitle: "Reliques Aztèques",
    menuTitle: "Collection aztèque",
    casketSubtitle: "Reliques du temple aztèque",
    relics: AZTEC_TEMPLE_RELICS,
  },
  {
    id: "egyptian",
    listTitle: "Reliques Égyptiennes",
    menuTitle: "Collection égyptienne",
    casketSubtitle: "Reliques du temple égyptien",
    relics: EGYPTIAN_TOMB_RELICS,
  },
  {
    id: "greek",
    listTitle: "Reliques Grecques",
    menuTitle: "Collection grecque",
    casketSubtitle: "Reliques du temple grec",
    relics: GREEK_TEMPLE_RELICS,
  },
  {
    id: "celtic",
    listTitle: "Reliques Celtiques",
    menuTitle: "Collection celtique",
    casketSubtitle: "Reliques du rituel celtique",
    relics: CELTIC_RITUAL_RELICS,
  },
  {
    id: "shinto",
    listTitle: "Reliques Shinto",
    menuTitle: "Collection shinto",
    casketSubtitle: "Reliques du sanctuaire shinto",
    relics: SHINTO_SHRINE_RELICS,
  },
  {
    id: "forgotten",
    listTitle: "Reliques Oubliées",
    menuTitle: "Collection oubliée",
    casketSubtitle: "Reliques du sanctuaire oublié",
    relics: FORGOTTEN_RELICS,
  },
  {
    id: "roman",
    listTitle: "Reliques Romaines",
    menuTitle: "Collection romaine",
    casketSubtitle: "Reliques de l'Empire romain",
    relics: ROMAN_EMPIRE_RELICS,
  },
  {
    id: "africanKingdom",
    listTitle: "Reliques Africaines",
    menuTitle: "Collection africaine",
    casketSubtitle: "Reliques des royaumes africains",
    relics: AFRICAN_KINGDOM_RELICS,
  },
  {
    id: "vikingRelics",
    listTitle: "Reliques Viking",
    menuTitle: "Collection viking",
    casketSubtitle: "Reliques des terres nordiques",
    relics: VIKING_RELICS,
  },
  {
    id: "mesopotamian",
    listTitle: "Reliques De Mésopotamie",
    menuTitle: "Collection mésopotamienne",
    casketSubtitle: "Reliques de Mésopotamie",
    relics: MESOPOTAMIAN_RELICS,
  },
  {
    id: "chinese",
    listTitle: "Reliques de Chine",
    menuTitle: "Collection chinoise",
    casketSubtitle: "Reliques de Chine",
    relics: CHINESE_RELICS,
  },
  {
    id: "persian",
    listTitle: "Reliques Perses",
    menuTitle: "Collection perse",
    casketSubtitle: "Reliques perses",
    relics: PERSIAN_RELICS,
  },
  {
    id: "medievalMonastery",
    listTitle: "Reliques médiévales",
    menuTitle: "Collection médiévale",
    casketSubtitle: "Reliques du monastère médiéval",
    relics: MEDIEVAL_MONASTERY_RELICS,
  },
  {
    id: "indianRelics",
    listTitle: "Reliques indiennes",
    menuTitle: "Collection indienne",
    casketSubtitle: "Reliques du temple indien",
    relics: INDIAN_TEMPLE_RELICS,
  },
  {
    id: "feodalJapanRelics",
    listTitle: "Reliques japonaises féodales",
    menuTitle: "Collection japonaise féodale",
    casketSubtitle: "Reliques du Japon féodal",
    relics: FEODAL_JAPAN_RELICS,
  },
];

export function findQuestTreasureCollectionIndex(collectionId) {
  if (!collectionId) return -1;
  return QUEST_TREASURE_COLLECTIONS.findIndex(
    (collection) => collection.id === collectionId
  );
}
